import i18n from '@/libs/i18n'
import axios from '@axios'
import { ref } from '@vue/composition-api'
import menuPayload, { localizedMenuText } from './menu-payload'

export { menuPayload }

export default function useMenuList() {
  function convertResource(resource, lang) {
    return {
      ...resource,
      title: localizedMenuText(resource.title, lang),
      description: localizedMenuText(resource.description, lang),
      lang,
      menuLink: { name: 'pages-menus-edit', params: { id: resource._id } },
    }
  }
  const currentLanguage = ref('fa')
  const refTable = ref(null)
  let requestSequence = 0
  const fetchList = params => {
    requestSequence += 1
    const sequence = requestSequence
    const lang = currentLanguage.value
    return axios.get('/menus', { params, headers: { lang } }).then(({ data }) => {
      if (sequence !== requestSequence || lang !== currentLanguage.value) throw new Error('Stale menu list response')
      return { data: data.data.map(row => convertResource(row, lang)), total: data.total }
    })
  }

  const tableColumns = [
    {
      key: 'title', label: i18n.t('general.title'), type: 'truncate-text', linkKey: 'menuLink', sortable: true,
    },
    { key: 'slug', label: 'Slug', sortable: true },
    {
      key: 'createdAt', label: i18n.t('general.createdAt'), type: 'dateTime', sortable: true,
    },
    { key: 'actions', label: i18n.t('general.actions'), sortable: false },
  ]
  return {
    moduleName: 'menus', endpoint: 'menus', tableColumns, convertResource, fetchList, currentLanguage, refTable,
  }
}
